import { connect } from 'react-redux'

import { setLanguage } from '../actions/localization'

const mapStateToProps = state => ({
  language: state.localization.language
})

const mapDispatchToProps = dispatch => ({
  setLanguage: lang => dispatch(setLanguage(lang))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)



// WEBPACK FOOTER //
// ./src/hocs/withLocalization.js